module.exports = __webpack_public_path__ + "static/media/mht_790_manitou_002.e891b0bc.png";